<template>
	<div class="home_doctor_card">
		<div
			class="bg_row"
			:class="{
            'team_style':type === 2
        }"
			@click="goDetail"
		>
			<img :src="detail.avatar" />
			<div class="content">
				<div class="value">{{ detail.name }}</div>
				<div class="label"> {{ detail.title }}</div>
				<div class="team"> {{type === 1? detail.hospitalName :detail.teamInfo&&detail.teamInfo.teamName}}</div>
			</div>
			<!-- <div class="right_icon"><van-icon name="arrow" /></div> -->
		</div>
		<!-- 团队详情弹窗 -->
		<DepartmentDetailDialog v-model="showTeamDetail" :item="detail.teamInfo||{}" :goMain="false" />
		<!-- 医生详情弹窗 -->
		<DoctorDetailDialog v-model="showDoctorDetail" :item="detail" :goMain="false" />
	</div>
</template>

<script>
import DoctorDetailDialog from '../../dpbind/components/doctor-detail-dialog.vue'
import DepartmentDetailDialog from './department-detail-dialog.vue'
export default {
    name: 'indicator-item',
    components: { DoctorDetailDialog, DepartmentDetailDialog },
    props: {
        type: {
            type: [String, Number],
            default: ''
        },
        detail: {
            type: Object,
            default: () => { }
        },
    },
    data () {
        return {
            showTeamDetail: false,
            showDoctorDetail: false,
        }
    },
    computed: {

    },
    methods: {
        goDetail () {
            if (this.type === 1) {
                this.showDoctorDetail = true
            }
            if (this.type === 2) {
                this.showTeamDetail = true
            }
        }
    }
};
</script>

<style scoped lang="less">
.home_doctor_card {
	background-image: url('../../../assets/img/doctor-bg.png');
	border-radius: 16px;
	overflow: hidden;
	width: 686px;
	height: 160px;
	background-size: 100%;
	padding-top: 98px;
	.bg_row {
		display: flex;
		align-items: center;
		padding: 0 26px;
		img {
			width: 100px;
			height: 100px;
			margin-right: 17.6px;
			border-radius: 50px;
		}
		.content {
			flex: 1;
			.value {
				font-size: 34px;
				line-height: 48px;
				margin-bottom: 5px;
				color: #000000;
			}
			.label {
				font-size: 26px;
				margin-bottom: 5px;
				color: #373c43;
			}
			.team {
				font-size: 26px;
				color: rgba(55, 60, 67, 0.8);
			}
		}
		.right_icon {
			font-size: 16px;
			color: #ffffff;
		}
	}
	.team_style {
		.content {
			// text-align: center;
		}
	}
}
</style>
